export default {
  fontWeight: 'inherit',
  fontStyle: 'inherit',
  fontFamily: 'inherit',
  textDecoration: 'inherit',
};
